<template>
  <header class="site-header">
    <div class="header-container">
      <div class="image-container">
        <router-link to="/">
          <img class="ranker-insights-logo" width="285" height="48" alt="Ranker Insights Logo" src="@/assets/images/ranker-insights-logo.png"/>
        </router-link>
        <div class="label">{{ labelText }}</div>
      </div>
      <SearchInput v-if="withSearch" :placeholder="placeholder" class="header-search-input small ml-auto mr-10" />
      <nav class="menu-links">
        <a v-if="isLoggedIn" :href="`${getInsightsUrl()}/logout`">Sign Out</a>
        <template v-else>
          <a :href="`${getInsightsUrl()}/login/account/register`">Register</a> <span class="divider">|</span> <a
            :href="`${getInsightsUrl()}/login`">Sign In</a>
        </template>
        <img role="button" width="20" height="16" alt="Menu" src="@/assets/icons/hamburger-menu.png" class="hamburglar"
             v-click-outside="hideMenu"
             v-if="isLoggedIn" @click="isMenuActive = !isMenuActive"/>
        <ul v-if="isLoggedIn && isMenuActive" class="dropdown-menu" aria-labelledby="dLabel">
          <!--<li>
            <router-link v-if="isAdmin" to="#user_mode" class="admin-option-toggle">
              <span class="hamburglar-item-text">admin mode</span>
            </router-link>
          </li>-->
          <li v-if="hasDataToolAccess">
            <a href="https://developers.ranker.com/" class="hamburglar-link" target="_blank">
              <span class="hamburglar-item-text">data tool</span>
            </a>
          </li>
          <li>
            <a :href="`${getInsightsUrl()}/logout`" class="hamburglar-link">
              <span class="hamburglar-item-text">logout</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import {isLoggedIn, isAdmin, isPaidUser, hasDataToolAccess} from '@/store/user';
import SearchInput from '@/components/ui/SearchInput';

export default {
  name: 'SiteHeader',
  components: {SearchInput},
  directives: {
    ClickOutside
  },
  props: {
    withSearch: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'Search'
    }
  },
  data() {
    return {
      isMenuActive: false
    };
  },
  computed: {
    hasDataToolAccess,
    isLoggedIn,
    isAdmin,
    isPaidUser,
    labelText() {
      if (this.isAdmin) {
        return 'Admin';
      }
      if (this.isPaidUser) {
        return 'Premium';
      }
      return '';
    }
  },
  methods: {
    getInsightsUrl() {
      return process.env.INSIGHTS_V1_HOST;
    },
    hideMenu() {
      this.isMenuActive = false;
    }
  }
};
</script>

<style lang="postcss">
.site-header {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 99;
  background: rgba(9, 10, 20, 0.9);
  backdrop-filter: blur(30px);
  height: 60px;
  @apply w-full flex justify-center;

  .header-container {
    padding: 0 50px 0 50px;
    max-width: 1440px;
    @apply w-full flex items-center justify-between;

    .image-container {
      @apply flex justify-start items-center;

      .label {
        font-family: Roboto Condensed, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 18px;
        letter-spacing: -0.01em;
        color: #FFFFFF;
        margin-left: 5px;
      }
    }
  }

  .ranker-insights-logo {
    width: 285px;
    height: 48px;
  }

  .menu-links {
    @apply flex items-center justify-end relative;

    .divider {
      margin: 0 20px;
    }

    > a, > span {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 17px;
      line-height: 20px;
      display: flex;
      align-items: center;
      text-align: right;
      font-feature-settings: 'ss04' on;
      color: #FFFFFF;
    }

    .hamburglar {
      @apply cursor-pointer;
      margin-left: 24px;

      &:hover {
        opacity: .75;
      }
    }

    .dropdown-menu {
      @apply absolute right-0 top-full border-none text-left list-none bg-white;
      box-shadow: 2px 2px 2px 0 rgba(93, 92, 92, .75);
      z-index: 1000;
      min-width: 160px;
      padding: 5px 0;
      margin: 2px 0 0;
      font-size: 14px;

      & > li {
        border-top: 1px solid #cbcbcf;
        height: 37px;
        background: inherit
      }

      & > li > a {
        background: inherit;
        padding: 3px 20px 3px 15px;
        display: block;
        clear: both;
        font-weight: 700;
        line-height: 1.42857143;
        white-space: nowrap;
      }

      & > li:first-child {
        border-top-width: 0
      }

      .hamburglar-item-text {
        display: inline-block;
        vertical-align: middle
      }

      .hamburglar-item-text {
        margin-top: 9px;
      }

      .hamburglar-link,
      .admin-option-toggle {
        font-size: 12px;
        color: #096dce;
        text-decoration: none;

        &:hover {
          @apply cursor-pointer;
          color: #0989ff;
        }
      }
    }
  }
}
</style>